<template>
  <MenuPopover
    v-if="!showNothing"
    class="ScopeMenu"
    trigger="click"
    placement="bottom"
    align="start"
    :bound-to="{ x: 'container' }"
    :bound-to-selector="within"
    :offset="{ y: 5 }"
    :trigger-attrs="{ title: $t('post_status.scope_menu') }"
    :items="items"
  >
    <template #trigger>
      <FAIcon
        :icon="icon(currentScope)"
        fixed-width
      />
      <span class="label">{{ $t(`general.scope_in_timeline.${currentScope}`) }}</span>
      <FAIcon
        class="chevron"
        icon="chevron-down"
      />
    </template>
  </MenuPopover>
</template>

<script src="./scope_menu.js"></script>

<style lang="scss">
@use "../../mixins";

.ScopeMenu {
  display: inline-flex;
}

.ScopeMenu > .popover-trigger-button {
  display: inline-flex;
  align-items: center;
  gap: 0.3em;
  min-width: 0;
  max-width: 100%;
  padding: 0.15em 0.6em 0.15em 0.5em;
  border-radius: var(--r-pill);
  box-shadow: inset 0 0 0 1px color-mix(in oklab, var(--link) 55%, transparent);
  color: var(--link);
  font-size: var(--fs-sm);
  line-height: 1.6;
  white-space: nowrap;

  /* also under the pointer, where unstyled buttons reset --icon */
  svg {
    color: var(--link);
  }

  .label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .chevron {
    font-size: 0.7em;
  }
}


/* a finger needs a taller pill */
@include mixins.touch {
  .ScopeMenu > .popover-trigger-button {
    min-height: 2.25rem;
  }
}
</style>
